export enum LocalStorageKeys {
  favoriteEvents = 'favorite-events',
}

export const clearLocalStorage = (localStorageKey: LocalStorageKeys) =>
  localStorage.removeItem(localStorageKey);

export const setLocalStorage = (localStorageKey: LocalStorageKeys, localStorageValue: string) => {
  try {
    localStorage.setItem(localStorageKey, localStorageValue);
  } catch (e) {
    console.log('local storage is not supported by browser');
  }
};

export const getLocalStorage = (localStorageKey: LocalStorageKeys) =>
  localStorage.getItem(localStorageKey);
